import axiosInstance from "./axiosInstance";

const payableService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/payables/create', payload)
            return response.data
        } catch (error) {
            console.log(error.response.data)
        }
    },
    fetchAll: async () => {
        try {
            const response = await axiosInstance.get('/payables/all')
            return response.data
        } catch (error) {
            console.log(error.response.data)
        }
    },
    fetch: async (id) => {
        try {
            const response = await axiosInstance.get('/payables/single/' + id)
            return response.data
        } catch (error) {
            console.log(error.response.data)
        }
    },
    fetchBySupplier: async (id) => {
        try {
            const response = await axiosInstance.get('/payables/supplier/' + id)
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
    update: async (id, payload) => {
        try {
            const response = await axiosInstance.put('/payables/update/' + id, payload)
            return response.data
        } catch (error) {
            console.log(error.response.data)
        }
    },
    clear: async (id) => {
        try {
            const response = await axiosInstance.put('/payables/clear/' + id)
            return response.data
        } catch (error) {
            console.log(error.response.data)
        }
    },
    delete: async (id) => {
        try {
            const response = await axiosInstance.delete('/payables/delete/' + id)
            return response.data
        } catch (error) {
            console.log(error.response.data)
        }
    }
}

export default payableService
